import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"
import ScrollTo from '@stimulus-components/scroll-to/dist/stimulus-scroll-to.umd.js'
const application = Application.start()
application.register('scroll-to', ScrollTo)
const context = require.context("site/controllers", true, /.js$/)
application.load(definitionsFromContext(context))